import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../../cache/CacheKeys'
import CacheManager from '../../../../cache/CacheManager'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import AccountPropertyUpdateModalUI from './AccountPropertyUpdateModalUI.js'

class AccountPropertyUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      propertyValue: null,
      propertyValueError: null,
      propertySelectList: []
    }
  }

  render() {

    let propertySelectListBool = [
      { key: '1', value: 'Yes' },
      { key: '0', value: 'No' },
    ]

    return (
      <AccountPropertyUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        propertyValue={this.state.propertyValue}
        onPropertyValueChange={(event) => { this.setState({ propertyValue: event.target.value }) }}
        propertyValueError={this.state.propertyValueError}
        setPropertyValueError={(error) => { this.setState({ propertyValueError: error }) }}
        propertyType={this.state.propertyType}
        propertySelectListBool={propertySelectListBool}
        propertySelectList={this.state.propertySelectList}
        selectedProperty={this.props.selectedProperty}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (!this.props.selectedProperty)
      return;

    if (prevProps.selectedProperty != null && this.props.selectedProperty.propertyCode === prevProps.selectedProperty.propertyCode)
      return;

    if (this.props.selectedProperty.propertyType) {
      if (this.props.selectedProperty.propertyType == 'value_set') {
        let propertySelectList = this.props.selectedProperty.valueArray.map((item, index) => {
          return { key: item, value: item };
        });
        this.setState({
          propertyValue: this.props.selectedProperty.propertyValue == null ? this.props.selectedProperty.defaultValue : this.props.selectedProperty.propertyValue,
          propertyType: this.props.selectedProperty.propertyType,
          propertySelectList: propertySelectList,
          selectedProperty: this.props.selectedProperty,
          submitted: false,
          errorList: null
        })
      }
      
      else {
        this.setState({
          propertyValue: this.props.selectedProperty.propertyValue == null ? this.props.selectedProperty.defaultValue : this.props.selectedProperty.propertyValue,
          propertyType: this.props.selectedProperty.propertyType,
          selectedProperty: this.props.selectedProperty,
          submitted: false,
          errorList: null
        })
      }
    }
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/properties/${this.props.selectedProperty.propertyCode}`,
      this.onSubmitCallback, {
      propertyValue: this.state.propertyValue,
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    let selectedProperty = this.props.selectedProperty
    this.props.selectedProperty.propertyValue = this.state.propertyValue
    this.props.onUpdate(selectedProperty)

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }
}

export default withRouter(AccountPropertyUpdateModalSF)
